<template>
  <div class="admin-new-order-builder-meta-item">
    <transition name="slide-x-transition" mode="out-in">
      <div class="text-right" v-if="showEmptyButton">
        <v-btn
          color="blue darken-2 white--text"
          outlined
          depressed
          small
          class="mt-2"
          :disabled="!!value"
          @click="add"
          >+ {{ label }}</v-btn
        >
      </div>
      <v-row dense class="text-right" v-else align="baseline" justify="end">
        <v-col cols="3" v-if="isOpened">
          <v-text-field
            :value="value_in_usd"
            autofocus
            type="number"
            :label="label"
            min="0"
            prefix="$"
            dense
            hide-details
            outlined
            @keydown.enter="isOpened = false"
            @input="$emit('update', $event * 100)"
          />
        </v-col>
        <v-col v-else class="text-h6"
          >{{ label }}: {{ formatUSD(value) }}</v-col
        >
        <BtnEdit @edit="isOpened = !isOpened" :on="isOpened" />
        <BtnRemove @remove="$emit('remove')" />
      </v-row>
    </transition>
  </div>
</template>

<script>
import formatUSD from '@/utils/formatUSD'
import BtnRemove from '@/components/BtnRemove'
import BtnEdit from '@/components/BtnEdit'

export default {
  name: 'AdminNewOrderBuilderMetaItem',
  components: {
    BtnRemove,
    BtnEdit,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      isOpened: false,
    }
  },
  computed: {
    value_in_usd() {
      return this.value / 100
    },
    showEmptyButton() {
      return !this.value && this.value !== 0
    },
  },
  methods: {
    add() {
      this.$emit('add')
      this.isOpened = true
    },
    formatUSD,
  },
}
</script>
